import styled from 'styled-components'
import { colors } from '@blocket/blocket-ui'
import styleguide from 'styleguide'
import ResponsivePage from 'components/ResponsivePage'

export const ColoredResponsivePage = styled(ResponsivePage)`
  background-color: var(--bui-background-secondar, initial);
  max-width: 678px;
  margin: 1px auto;
  overflow: hidden;
`

export const FullHeightWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${colors.grey100};
`

export const ContentWrap = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  display: flex;
  padding-top: 0;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: ${styleguide.padding.small}px;
  column-gap: 1rem;
  row-gap: 0.5rem;

  @media (min-width: 768px) {
    width: 678px;
    height: 410px;
    flex-wrap: wrap;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  column-gap: 1rem;
  row-gap: 0.5rem;
`
